import * as service from '../healthsafety.service'
import incidentAndAccidentTable from './incidentAndAccidentTable'
import incidentForm from './incidentForm'
import accidentForm from './accidentForm'
export default {
  components: {
    incidentAndAccidentTable,
    incidentForm,
    accidentForm
  },
  
  data() {
    return {
      /*** FG - FOOF ********************************************************
      ** NOTE: the variable below is set to "this" at beforeMount time and **
      ** is passed along to the templates that are used to display the     **
      ** table displaying incidents/accidents, and the forms               **
      ** ACCORDING TO Vue DOCS THOSE TEMPLATES SHOULD BE ABLE TO USE       **
      ** $parent IN ORDER TO GET TO THE DATA, METHODS, ETC. IN THIS        **
      ** CONTROLLER BUT THAT DOES NOT WORK WHEN THE TEMPLATE IS INSIDE OF  **
      ** AND "el-xxx" TAG.                                                 **
      **********************************************************************/
      thisController: null,
      timepickerformat: 'hh:mm:ss a',
      compliance_columns: ['Title', 'IncidentDate', 'IncidentType', 'Severity', 'ViolatorClass', 'BehaviorType', 'SubmittedBy', 'Actions'],
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        columnsClasses: {'Actions':'hydroware-2-button-column'},
        headings: {
          Title: 'Title',
          IncidentDate: 'Date',
          IncidentType: 'Incident Type',
          ViolatorClass: 'Violator',
          BehaviorType: 'Behavior',
          SubmittedBy: 'Submitted By',
          Actions: ''
        },
        labelPosition: 'top',
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: ['IncidentDate'],
        orderBy: {
          column: 'IncidentDate',
          ascending: false
        },
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      Locations: [],
      PoolId: '',
      Incident: {

        'Title': '',
        'IncidentDate': '',
        'IncidentTime': '',
        'Description': '',
        'IncidentType': '',
        'Severity': '',
        'ViolatorClass': '',
        'BehaviorType': '',
        'Area': '',
        'SubmittedBy': '',
        'PoolID': '',
        'PoolName': '',
        'AddedBy': '',
        'AddedByName': '',
        'RoleId': '',
        'RoleName': '',
        'NatureOfIncident': '',
        // 'Location': '',
        'PositionId': '',
        'LocationId': '',
        'Response': '',
        'Police': false,
        'PoliceCase': '',
        'FireDepartment': false,
        'FireDepartmentCase': '',
        'FirstAidAdministered': false,
        'Injury': '',
        'Treatment': '',
        'InjuryType': '',
        'Supervisor': '',
        'SupervisorName': '',
        'SupervisorLocation': '',
        'Lifeguard': '',
        'LifeguardName': '',
        'LifeguardLocation': '',
        'AdvancedMedicalCare': false,
        'AdvancedMedicalCarePlace': '',
        'AdvancedMedicalCareInformation': '',
        'EMS': false,
        'EMSCase': '',
        'AddedOn': '',
        'ModifiedBy': '',
        'ModifiedOn': '',
        'PoolType': '',
        'NatureOfIncidentOther': '',
        'ViolatorClassOther': '',
        'BehaviorTypeOther': '',
        'InjuryTypeOther': '',
        'AddOnTime': '',
        'Attachments': [],
        'IncidentInvolvedPartyList': [],
        'IncidentStaffOnDutyList': [],
        'IncidentWitnessList': [],
        'IncidentVictimsList': [],
        'OtherTypeIncident': '',
        'OtherTypeBehavior': '',
        'OtherTypeAccidents': '',
        'OtherAccidentsBehaviour': '',
        'OtherInjuries': '',
        'LocationText': '',
        'ManagerOnDuty': '',
        'StaffOther': '',
        'ReportPreparedByOther': '',
        'ManagerOnDutyOther': '',
        'ViolatorOther': '',
        'StaffOther': ''
      },

      displayDate: '',

      // rules: {
      //   ZipCode: [
      //     { type: 'number', required: false, message: 'Please pick a time', trigger: 'change' }
      //   ]
      //       },
      value4: [],
      uindex: '',

      supervisors: [],

      staffmembers: [],
      roles: [],
      incidents: [],
      pools: [],

      locationId: '',
      IsCurrentReportDate: false,
      IsCurrentReportTime: false,
      locationName: '',
      modalTitle: '',

      isediting: false,
      isaddding: false,

      isAddingOrEditing: "", //FG - FOOF - After Cert - First Release Security (7) - added to control enable/disable of form fields

      poolTypes: [],
      lifeguards: [],
      Severitys: [],
      Violator: [],
      Behavior: [],
      injuryType: [],
      locationName: '',
      incidentId: '',
      isDashboardView: false,
      isIncidentType: false,
      isincidentdisabled: false,
      isaccidentdisabled: false,
      PoolName: '',
      PoolIdEdit: ''

    }
  },
  beforeMount() {
    this.thisController=this;
  },
  mounted() { 
    let context = this
    this.DashboardRedirection()
    this.$router.app.$on('emittedlocation_obj', (data) => {

      if (!context.isDashboardView) {

        context.locationId = data.LocationId ? data.LocationId : 0
        context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      }
    })
    this.$router.app.$on('emittedpool_obj', (data) => {
      if (!context.isDashboardView) {

        context.PoolId = data.PoolId ? data.PoolId : ''
        context.PoolName = data.PoolName ? '(Aquatic Venue : ' + data.PoolName + ')' : ''
      }
      if (context.locationId && context.PoolId) {
        context.GetAllIncidents(context.locationId, context.PoolId)
      }
      if (context.locationId) {

        context.GetAllStaffMember(context.locationId)
      }
    })
    context.GetAllSupervisor()
    context.GetAllRoles()
    context.GetAllLifeguard()
    // context.GetAllPoolsByUserName()
    this.poolTypes = ['Accident', 'Medical', 'Contamination', 'Behavior', 'Weather', 'Outage', 'Disaster', 'Crime']
    this.IncidentTypes = ['Crime', 'Defective Equipment', 'Medical', 'Other']
    this.AccidentTypes = ['Drowning', 'Medical Condition', 'Slip/Fall', 'Spinal Injury', 'Water-Entry Injury', 'Weather', 'Other']
    this.Severitys = ['High', 'Medium', 'Low']
    this.Violator = ['Patron', 'Member', 'Guest', 'Employee', 'Other']
    this.IncidentBehavior = ['Disorderly Conduct', 'Fighting', 'Safety Disregard', 'Other']
    this.AccidentBehavior = ['Defective Equipment', 'Lack of Knowledge/Skills', 'Personal Factors', 'Safety Disregard', 'Other']
    this.injuryType = ['Cut', 'Dislocation', 'Puncture Wound', 'Diabetic Emergency', 'Bruise', 'Burn', 'Near Drowning', 'Respiratory Emergency', 'Fracture', 'Poisoning', 'Heart Attack', 'Sudden Illness', 'Sprain/Strain', 'Amputation', 'Stroke', 'Fainting', 'Other']
  },
  beforeDestroy() {

    //this.$root.$off('emittedpool_obj') //FG - After Cert - First Release Security (7) - discovered after writing security for this page... this SHOULD NOT BE TURNED OFF !!!!!!
    //this.$root.$off('emittedlocation_obj') //FG - FOOF - Jan 23 2019
  },
  methods: {

    addCompliancevit() {
      this.isaddding = true
      this.isAddingOrEditing = "A"

      this.Incident = {

        'Title': '',
        'IncidentDate': '',
        'IncidentTime': '',
        'Description': '',
        'IncidentType': 'Incident',
        'Severity': '',
        'ViolatorClass': '',
        'BehaviorType': '',
        'Area': '',
        'SubmittedBy': '',
        'PoolID': '',
        'PoolName': '',
        'AddedBy': '',
        'AddedByName': '',
        'PositionId': '',
        'RoleName': '',
        'NatureOfIncident': '',
        // 'Location': '',
        'LocationId': '',
        'Response': '',
        'Police': false,
        'PoliceCase': '',
        'FireDepartment': false,
        'FireDepartmentCase': '',
        'FirstAidAdministered': false,
        'Injury': '',
        'Treatment': '',
        'InjuryType': '',
        'Supervisor': '',
        'SupervisorName': '',
        'SupervisorLocation': '',
        'Lifeguard': '',
        // 'LifeguardName': '',
        'AdvancedMedicalCare': false,
        'AdvancedMedicalCarePlace': '',
        'AdvancedMedicalCareInformation': '',
        'EMS': false,
        'EMSCase': '',
        'AddedOn': '',
        'ModifiedBy': '',
        'ModifiedOn': '',
        'PoolType': '',
        'NatureOfIncidentOther': '',
        'ViolatorClassOther': '',
        'BehaviorTypeOther': '',
        'InjuryTypeOther': '',
        'AddOnTime': '',
        'Attachments': [],
        'IncidentInvolvedPartyList': [],
        'IncidentStaffOnDutyList': [],
        'IncidentWitnessList': [],
        'IncidentVictimsList': [],
        'ManagerOnDuty': '',
        'StaffOther': '',
        'ReportPreparedByOther': '',
        'ManagerOnDutyOther': '',
        'ViolatorOther': '',
        'StaffOther': ''
      }
      this.PoolIdEdit = this.PoolId
      this.IsCurrentReportDate = true
      this.IsCurrentReportTime = true
      this.GetPoolsByLocation(this.locationId)
      this.displayDate = ''

      if (this.ttypes) {

        this.Training.TrainingTypeId = this.ttypes[0].Id
        this.GetEquipments(this.Training.TrainingTypeId)
        this.GetSupplyItems(this.Training.TrainingTypeId)
        this.GetMahcCodes()
      }

    },
    showCompliancevit() {
      this.isaddding = false
      this.isediting = false
      this.isAddingOrEditing = ""
    },

    addInvolvedParty() {

      this.Incident.IncidentInvolvedPartyList.push({
        Name: '',
        Address: '',
        City: '',
        State: '',
        ZipCode: '',
        PhoneNumber: '',
        Age: ''

      })

    },
    addWitness() {
      this.Incident.IncidentWitnessList.push({
        Name: '',
        Address: '',
        PhoneNumber: '',

      })
    },
    addStaff() {
      this.Incident.IncidentStaffOnDutyList.push({
        StaffId: '',
        StaffOther: ''

      })
    },

    addVictim() {
      this.Incident.IncidentVictimsList.push({
        Name: '',
        Address: '',
        PhoneNumber: '',
        Age: '',
        Activity: ''

      })
    },

    setFilename: function (e, row) {
      // var file = event.target.files[0];

      var t = []
      for (var i = 0; i < e.target.files.length; i++) {
        var reader = new FileReader()
        t.push({
          'FileName': e.target.files[i].name,
          'MediaType': e.target.files[i].type,
          'Buffer': reader.readAsArrayBuffer(e.target.files[i])
        })
      }
      this.Training.TrainingSessions[row].Attachments = t
      //row.file = file
    },
    userAppend(val) {


      // alert(JSON.stringify(this.value4))

      this.Training.TrainingSessions[this.uindex].UserIds = val
    },
    addUser(index, data) {
      this.uindex = index
      this.value4 = data
      $('#AttendeesModal').modal('show')
    },
    addSupply() {
      this.Training.SupplyItems.push({

        SupplyItemId: '',
        Quantity: ''

      })

    },

    addEquipment() {
      this.Training.Equipments.push({
        EquipmentId: '',
        Quantity: ''

      })
    },

    removeWitness(index) {
      this.Incident.IncidentWitnessList.splice(index, 1)
    },
    removeInvolved(index) {
      this.Incident.IncidentInvolvedPartyList.splice(index, 1)
    },
    removeStaff(index) {
      this.Incident.IncidentStaffOnDutyList.splice(index, 1)
    },
    removeVictim(index) {
      this.Incident.IncidentVictimsList.splice(index, 1)
    },
    removeWitness(index) {
      this.Incident.IncidentWitnessList.splice(index, 1)
    },
    GetAllIncidents(id, poolid) {
      let context = this
      loader.startLoader()
      service.GetAllIncidents(id, poolid).then(function (response) {

        //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
        if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
          context.incidents = []
          loader.stopLoader()
          return;
        }

        if (response && response != null) {

          context.incidents = response
          tooltip.startTooltip(50)
        } else {

          context.incidents = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllSupervisor() {
      let context = this
      loader.startLoader()
      service.GetAllSupervisor().then(function (response) {

        if (response && response != null) {
          context.supervisors = response

        } else {

          context.supervisors = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllRoles() {
      let context = this
      loader.startLoader()
      service.GetAllRoles().then(function (response) {
        if (response && response != null) {
          context.roles = response

        } else {

          context.roles = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllStaffMember(lid) {

      let context = this
      loader.startLoader()
      service.GetUsersByLocation(lid ? lid : context.locationId).then(function (response) {

        if (response && response != null) {
          context.staffmembers = response
          context.staffmembers.push({
            'Id': '0',
            'Name': 'Other'
          })

        } else {

          context.staffmembers = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetAllLifeguard() {
      let context = this
      loader.startLoader()
      service.GetAllLifeguard().then(function (response) {

        if (response && response != null) {
          context.lifeguards = response

        } else {

          context.lifeguards = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllPoolsByUserName() {
      let context = this
      loader.startLoader()
      service.GetAllPoolsByUserName().then(function (response) {

        if (response && response != null) {
          context.pools = response

        } else {

          context.pools = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    view(data) {

      this.Incident = data.row
      $('#IncidentModal').modal('show')
    },

    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },

    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del: function (data) {
      var ID = data.row.Id
      let context = this
      var opts = {message: 'Are you sure you want to delete ' + data.row.Title +'?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteIncidentAccidentRow.bind(null,ID))
    },
    deleteIncidentAccidentRow(ID) {
      var context = this;
      loader.startLoader()
      service.DeleteIcident(ID).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
          loader.stopLoader()
          return;
        }

        context.GetAllIncidents(context.locationId, context.PoolId)
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);

      }, (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    
    },

    editcol: function (data) {
      // this.PoolIdEdit = this.PoolId
      this.IsCurrentReportDate = false,
        this.IsCurrentReportTime = false
      this.GetPoolsByLocation(this.locationId)
      this.PoolIdEdit = data.row.PoolID
      if (data.row.IncidentType == 'Incident') {
        if (this.IncidentTypes.indexOf(data.row.PoolType) < 0) {
          data.row.OtherTypeIncident = data.row.PoolType
          data.row.PoolType = 'Other'
        }
        if (this.IncidentBehavior.indexOf(data.row.BehaviorType) < 0) {
          data.row.OtherTypeBehavior = data.row.BehaviorType
          data.row.BehaviorType = 'Other'
        }

      } else {
        if (this.AccidentTypes.indexOf(data.row.PoolType) < 0) {
          data.row.OtherTypeIncident = data.row.PoolType
          data.row.PoolType = 'Other'
        }
        if (this.AccidentBehavior.indexOf(data.row.BehaviorType) < 0) {
          data.row.OtherTypeBehavior = data.row.BehaviorType
          data.row.BehaviorType = 'Other'
        }
        if (this.injuryType.indexOf(data.row.InjuryType) < 0) {
          data.row.OtherInjuries = data.row.InjuryType
          data.row.InjuryType = 'Other'
        }

      }
      var ID = data.row.Id
      let context = this
      context.EditableColID = ID
      context.Incident = data.row
      context.Incident['Id'] = ID
      //context.Incident['PlanDate'] = new Date(data.row['PlanDate'])
      if (this.Incident.IncidentDate) {
        //FG - FOOF - May 5 2019 - I FOUND THE LINE BELOW WHEN LOOKING TO REPLACE THE TIME PICKER
        //     WHY WOULD THEY HAVE SET THE ADDEDON DATE TO THE INCIDENT DATE ????
        //this.Incident.AddedOn = this.Incident.IncidentDate
        this.Incident.IncidentDate = new Date(this.Incident.IncidentDate)
      }
      context.isediting = true
      context.isAddingOrEditing = "E"

    },

    CreateIncident(formName) {

      let context = this
      if (this.Incident.BehaviorType == 'Other' && this.Incident.OtherTypeBehavior != '') {
        this.Incident.BehaviorType = this.Incident.OtherTypeBehavior
      }
      if (this.Incident.PoolType == 'Other' && this.Incident.OtherTypeIncident != '') {
        this.Incident.PoolType = this.Incident.OtherTypeIncident
      }
      if (this.Incident.IncidentType == 'Accident') {
        if (this.Incident.InjuryType == 'Other') {
          this.Incident.InjuryType = this.Incident.OtherInjuries
        }
      };
      if (this.IsCurrentReportDate && context.Incident.IncidentType != "Accident") {

        this.Incident.AddedOn = new Date().getMonth() + 1 + "-" + new Date().getDate() + "-" + new Date().getFullYear();
      }

      if (this.IsCurrentReportTime) {

        this.Incident.AddOnTime = new Date()
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()
          context.Incident.LocationId = context.locationId
          context.Incident.PoolID = context.PoolIdEdit
          if (context.Incident.IncidentDate) {
            context.Incident.IncidentDate = context.$options.filters.fdate(context.Incident.IncidentDate)
          }

          if (context.Incident.AddedOn) {
            context.Incident.AddedOn = context.$options.filters.fdate(context.Incident.AddedOn)

          }
          context.Incident.SubmittedBy = authDetails.FirstName + ' ' + authDetails.LastName

          /*          context.addMaintenance['LocationId'] = context.locationId
           context.addMaintenance['PlanDate'] = context.$options.filters.fdate(context.addMaintenance['PlanDate'])*/

          service.CreateIncident(context.Incident).then(function (response) {
            loader.stopLoader()

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
              return;
            }

            context.$notify({
              title: 'Success',
              message: 'Incident  Created',
              type: 'success'
            })
            context.GetAllIncidents(context.locationId, context.PoolId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing = ""

          }, (error) => {
            /*            context.addMaintenance['PlanDate'] = new Date(context.addMaintenance['PlanDate'])*/

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          return false
        }
      })
    },

    UpdateIncident(formName) {

      this.Incident.PoolID = this.PoolIdEdit
      this.Incident.LocationId = this.locationId
      if (this.Incident.BehaviorType == 'Other' && this.Incident.OtherTypeBehavior != '') {
        this.Incident.BehaviorType = this.Incident.OtherTypeBehavior
      }
      if (this.Incident.PoolType == 'Other' && this.Incident.OtherTypeIncident != '') {
        this.Incident.PoolType = this.Incident.OtherTypeIncident
      }
      if (this.Incident.InjuryType == 'Other') {
        this.Incident.InjuryType = this.Incident.OtherInjuries
      }
      if (this.IsCurrentReportDate) {

        this.Incident.AddedOn = new Date().getMonth() + 1 + "-" + new Date().getDate() + "-" + new Date().getFullYear();
      }

      if (this.IsCurrentReportTime) {

        this.Incident.AddOnTime = new Date()
      }

      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          if (context.Incident.IncidentDate) {
            context.Incident.IncidentDate = context.$options.filters.fdate(context.Incident.IncidentDate)
          }
          if (context.Incident.AddedOn) {
            context.Incident.AddedOn = context.$options.filters.fdate(context.Incident.AddedOn)

          }
          context.Incident.SubmittedBy = authDetails.FirstName + ' ' + authDetails.LastName

          /* context.addMaintenance['LocationId'] = context.locationId
           context.addMaintenance['PlanDate'] = context.$options.filters.fdate(context.addMaintenance['PlanDate'])*/
          // context.addCompliance['Id'] =
          service.UpdateIncident(context.Incident).then(function (response) {
            loader.stopLoader()

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
              return;
            }

            context.$notify({
              title: 'Success',
              message: 'Incident details Updated',
              type: 'success'
            })
            context.GetAllIncidents(context.locationId, context.PoolId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing = ""

          }, (error) => {
            /*  context.addMaintenance['PlanDate'] = new Date(context.addMaintenance['PlanDate'])*/
            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'INCIDENTS - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    /*Purpose-Used to identify whether the page is redirected from dashboard by checking querystring
     Assigns values to variables to show only edit portion,disable radio button
     and call to load data by passing id    */
    DashboardRedirection() {
      if (this.getParameterByName('locationId')) {
        this.GetPoolsByLocation(this.getParameterByName('locationId'))
        this.GetAllStaffMember(this.getParameterByName('locationId'))
      }

      this.incidentId = this.getParameterByName('id')
      let context = this
      if (this.incidentId != null && this.incidentId != '') {
        context.isDashboardView = true
        context.isediting = true
        context.isAddingOrEditing = "E"
        if (context.getParameterByName('type').toLowerCase() == 'incident') {

          context.isIncidentType = true
          context.Incident.IncidentType = 'Incident'
          context.isaccidentdisabled = true
          context.GetIncidentByID(context.incidentId)
        }
        if (context.getParameterByName('type').toLowerCase() == 'accident') {

          context.isIncidentType = false
          context.Incident.IncidentType = 'Accident'
          context.isincidentdisabled = true
          context.GetIncidentByID(context.incidentId)
        }

        // context.GetIncidentByID(context.incidentId)

      }

    },
    /*Purpose-to get value of querystring parameters
     Argument name-Name of the parameter to get the value
     Url-any specific url if any,if not current url is automically used*/

    getParameterByName(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    /*To get incident/accident details from the service and assign it to incident to populate the fields
     (Used when the redirection occurs from the dashboard)*/

    GetIncidentByID(id) {
      let context = this
      service.GetIncidentById(id).then(function (response) {
        if (response && response != null) {

          context.Incident = response
          context.PoolIdEdit = response.PoolID
          context.locationName = ' - ' + context.Incident.LocationName
          context.PoolName = '(Aquatic Venue : ' + context.Incident.PoolName + ')'
          tooltip.startTooltip(50)
        } else {
          context.Incident = ''
        }
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetPoolsByLocation(id) {
      let context = this

      service.GetPools(id).then(function (response) {
        context.pools = response
      })
    },
    //to redirect to dashboard page
    rediectToDashboard() {
      this.$router.push('dashboard')
    },

  },
  watch: {
    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {

      this.$router.app.$emit('sidebar_hide', val)
    },
    '$route' (to, from) {

      this.stateName = to.name
      if (from.name == 'incidents') {

        this.isDashboardView = false
        this.isIncidentType = false
        this.isincidentdisabled = false
        this.isaccidentdisabled = false
        this.isediting = false
        this.isaddding = false
        this.isAddingOrEditing = ""
      }
    }

  },

}



// WEBPACK FOOTER //
// ./src/pages/HealthSafety/IncidentAccident/incidents.controller.js